"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SYNC_PRODUCT_TREE = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.SYNC_PRODUCT_TREE = (0, gql_1.gql)(`
  mutation SyncProductTree($childTreeId: ID!, $conflictResolution: ConflictResolution) {
    syncProductTree(input: {
      childTreeId: $childTreeId,
      clientMutationId: "",
      conflictResolution: $conflictResolution,
    }) {
      success
      error
      result {
        lastSyncedAt
      }
    }
  }
`);
